import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaEnvelope, FaSpinner, FaArrowLeft, FaCheckCircle } from "react-icons/fa";
import "../styles/AuthForm.css";
import "../styles/RecoverPassword.css";
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(
        "https://reanimeitor.com/backend/forgot_password.php",
        { email: email },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setSent(true);
      } else {
        setError(response.data.error || "Error al enviar el email");
      }
    } catch (err) {
      setError("Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-container">
      <div className="auth-form-header">
        <div className="auth-form-logo">
          <span className="auth-form-logo-icon">⚡</span>
          <span className="auth-form-logo-text">Reanimeitor</span>
        </div>
        <h2 className="auth-form-title">¿Olvidaste tu contraseña?</h2>
        <p className="auth-form-subtitle">Te enviaremos un enlace para restablecerla</p>
      </div>

      {sent ? (
        <div className="verification-success">
          <div className="success-animation">
            <FaCheckCircle className="success-icon" />
          </div>
          <h3>¡Email enviado!</h3>
          <p>Revisa tu bandeja de entrada (y spam) para restablecer tu contraseña.</p>
          <Link to="/login" className="auth-link" style={{ marginTop: '20px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            <FaArrowLeft /> Volver al inicio de sesión
          </Link>
        </div>
      ) : (
        <>
          {error && <div className="form-error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-with-icon">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  className="form-input"
                  placeholder="tu@email.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={loading || !email}
            >
              {loading ? (
                <div className="loading-spinner">
                  <div className="spinner"></div>
                  Enviando...
                </div>
              ) : "Enviar enlace de restablecimiento"}
            </button>

            <div className="auth-footer" style={{ marginTop: '20px' }}>
              <Link to="/login" className="auth-link">
                <FaArrowLeft /> Volver al inicio de sesión
              </Link>
            </div>
          </form>
        </>
      )}
    </div>
  );
}